import React from 'react';
import Header from './Header';
import Footer from './Footer';

export const ReturnPolicy = () => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen flex flex-col">
      <Header />

      <main className="max-w-4xl mx-auto px-6 py-12 bg-white shadow-md rounded-md my-10">
        <h1 className="text-4xl font-bold text-[rgb(0,131,234)] mb-6">Return Policy</h1>
        <p className="text-gray-700 mb-4"><strong>Effective Date:</strong> July 29, 2025</p>

        <p className="text-gray-700 mb-4">
          Wentago offers non-tangible, digital goods. As such, all purchases made for our Chrome extensions and subscriptions are considered final.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">1. No Refunds for Digital Products</h2>
        <p className="text-gray-700 mb-4">
          Due to the nature of our services, we do not provide refunds once a subscription or license has been activated and access has been granted.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">2. Exceptions</h2>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li>Duplicate charges for the same subscription</li>
          <li>Technical issues reported within 7 days of purchase</li>
          <li>Activation failure not resolved by support</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">3. Requesting a Refund</h2>
        <p className="text-gray-700 mb-4">
          If you qualify, contact us with:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li>Your purchase email</li>
          <li>Date of transaction</li>
          <li>Reason for refund</li>
        </ul>

        <p className="text-gray-700 mb-4">
          Email: <a className="text-[rgb(0,131,234)] font-medium" href="mailto:kontakt@wentago.pl">kontakt@wentago.pl</a>
        </p>

        <p className="text-sm text-gray-500 mt-8">Last updated: July 29, 2025</p>
      </main>

      <Footer />
    </div>
  );
};

export const TermsOfService = () => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen flex flex-col">
      <Header />

      <main className="max-w-4xl mx-auto px-6 py-12 bg-white shadow-md rounded-md my-10">
        <h1 className="text-4xl font-bold text-[rgb(0,131,234)] mb-6">Terms of Service</h1>
        <p className="text-gray-700 mb-4"><strong>Effective Date:</strong> July 29, 2025</p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">1. Acceptance</h2>
        <p className="text-gray-700 mb-4">
          By using our extensions, you agree to these Terms of Service. If you disagree, do not use our products.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">2. License</h2>
        <p className="text-gray-700 mb-4">
          We grant a non-exclusive, non-transferable license to use our extensions on compatible browsers.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">3. Restrictions</h2>
        <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
          <li>No redistribution or resale</li>
          <li>No reverse engineering or modification</li>
          <li>No illegal use of the product</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">4. Payments</h2>
        <p className="text-gray-700 mb-4">
          Paddle handles all billing. Subscriptions renew automatically unless cancelled.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">5. Termination</h2>
        <p className="text-gray-700 mb-4">
          We reserve the right to suspend or revoke access if you violate these terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">6. Disclaimer</h2>
        <p className="text-gray-700 mb-4">
          We provide the extensions "as is" without warranty. We are not liable for damages or losses.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">7. Contact</h2>
        <p className="text-gray-700 mb-4">
          Email us with any concerns: <a className="text-[rgb(0,131,234)] font-medium" href="mailto:kontakt@wentago.pl">kontakt@wentago.pl</a>
        </p>

        <p className="text-sm text-gray-500 mt-8">Last updated: July 29, 2025</p>
      </main>

      <Footer />
    </div>
  );
};
